module.exports = __webpack_public_path__ + "img/play.de780723.svg";